var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],ref:"dropBox",staticClass:"dropBox"},[_c('div',{staticClass:"tip1"},[_vm._v(" 将视频拖拽到此处 ")]),_c('div',{staticClass:"tip2"},[_vm._v(" 最多支持5个视频 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }